import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@app/auth/auth.service';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  const router = inject(Router);

  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  return next(req).pipe(
    catchError((error) => {
      const message = error?.error?.message;
      
      // Handle 401 Unauthorized error
      if (error.status === 401 && message === 'Unauthenticated.') {
        // Delete the token and user from local storage
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        router.navigate(['/login']);
      }
  
      return throwError(() => error);
    })
  );

};